import React, { FC } from 'react';
import { formatString } from 'utils/helperMethods';

type Props = {
    lenses: LensType[];
    onClick?: (lens: LensType, index: number) => void;
    activeLensKey: number;
};

type LensType = {
    label: string;
    key: number;
};

const LensesTabsContainer: FC<Props> = ({ lenses = [], onClick, activeLensKey }) => {
    return (
        <div className="flex gap-2 pb-1 pr-2 relative top-[1px] overflow-x-auto w-full items-center">
            {lenses.map((lens, index) => {
                const isActive = lens.key === activeLensKey;
                return (
                    <div
                        onClick={() => onClick && onClick(lens, index)}
                        key={lens.label}
                        className={` px-3 py-[5px] border-b  ${
                            onClick ? 'cursor-pointer' : 'cursor-default'
                        } transition-all rounded ${
                            isActive
                                ? ' border-darkBlue bg-backgroundGreyAlt4 min-w-[248px] flex-grow-[3]'
                                : 'min-w-[218px] border-white flex-grow-[2] bg-backgroundGreyAlt3'
                        } `}
                    >
                        <p
                            title={lens.label}
                            className={`text-center  ${isActive ? 'text-darkBlueAlt' : 'text-promoColour'} font-bold`}
                        >
                            {isActive ? lens.label : formatString(lens.label, 25)}
                        </p>
                    </div>
                );
            })}
        </div>
    );
};

export default LensesTabsContainer;
